import React, { Component } from "react"
import CategoryConverter from "../utils/categoryConverter"

class FoodCategories extends Component {
  render() {
    const { cats } = this.props
    const res = CategoryConverter(cats.nodes)

    return <>{res}</>
  }
}

export default FoodCategories
